import { Stack } from '@mui/material'
import { Dialogs, useDialogs } from '../../Contexts/DialogsContext'
import { useGlobalContext } from '../../Contexts/GlobalContext'
import SettingsDialog from '../../settings/SettingsDialog'
import { SUPPORT_LINK } from '../../utils/links'
import { AchievementsIcon } from '../icons/achievements'
import { GameHistoryIcon } from '../icons/game_history'
import LogoutIcon from '../icons/logout'
import ProfileIcon from '../icons/profile'
import SettingsIcon from '../icons/settings'
import { StatsIcon } from '../icons/stats'
import SupportIcon from '../icons/support'
import Dropdown, { DropdownMenuItem } from './Dropdown'

export interface UserMenuProps {
    Link: any
}

const UserMenu = (props: UserMenuProps) => {
    const { Link } = props
    const { playAreaURL, isGuest, userData, logoutHandler } = useGlobalContext()
    const { registerDialog } = useDialogs()

    const onSettings = () => {
        registerDialog(Dialogs.SETTINGS, <SettingsDialog />)
    }

    const onLogout = () => {
        logoutHandler()
    }

    let userNavigation: Omit<DropdownMenuItem, 'key'>[] = [
        { title: 'Account', icon: <ProfileIcon />, link: `${playAreaURL}/profile/account` },
        { title: 'Stats', icon: <StatsIcon />, link: `${playAreaURL}/profile/stats` },
        { title: 'Achievements', icon: <AchievementsIcon />, link: `${playAreaURL}/profile/missions?tab=achievements` },
        { title: 'Game History', icon: <GameHistoryIcon />, link: `${playAreaURL}/profile/game-history` },
        { title: 'Settings', icon: <SettingsIcon />, onClick: onSettings },
        { title: 'Help', icon: <SupportIcon />, link: SUPPORT_LINK, target: '_blank' },
        ...(!isGuest ? [{ title: 'Log out', icon: <LogoutIcon />, onClick: onLogout }] : []),
    ]

    if (!userData) return null

    return (
        <Stack
            direction="row"
            sx={{
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Dropdown
                dropdownItems={userNavigation}
                userData={userData}
                reward={userData?.reward}
                Link={Link}
                variant="profile"
            />
        </Stack>
    )
}

export default UserMenu
